// Libraries
import { useState, useEffect } from 'react';

// Utilities
import compareTimes from '../utils/date/compareTimes';

/**
 * @const useCountdownTimer
 * Sets a countdown timer
 *
 * @param {Date} time A time to count down towards
 * @return {number} Time in seconds between the current time and the target time
 */
function useCountdownTimer(time: Date): number {
    const [difference, setDifference] = useState(compareTimes(time));

    useEffect(() => {
        const interval = setInterval(() => {
            if (difference <= 0) {
                clearInterval(interval);
                return;
            }

            return setDifference(() => {
                return compareTimes(new Date(time));
            });
        }, 1000);
        return () => clearInterval(interval);
    }, [difference]);

    return difference;
}

// Exports
export default useCountdownTimer;
